import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  CircularProgress,
  Alert,
  Stack,
  useTheme,
} from "@mui/material";
import { useWebsiteScrape } from "../../../contexts/WebsiteScrapeContext";

export default function AddHomePage({ closeModal, refresh, handleRefresh, chatbotId, permission }) {
  const theme = useTheme();
  const { isProcessing, startSitemapAdd } = useWebsiteScrape();

  useEffect(() => {
    document.title = "Add Homepage | KlonIT Web Application";
  }, []);

  const [inputValue, setInputValue] = useState("");
  const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,}([\/\w .-]*)*\/?$/i;
  const [error, setError] = useState(null);

  const handleAddWebBtnClick = async () => {
    if (urlRegex.test(inputValue)) {
      setError(null);
      const url = inputValue.trim();
      setInputValue("");
      closeModal();
      startSitemapAdd(url, chatbotId, 'Homepage');
      handleRefresh();
    } else {
      setError("Please enter a valid Homepage URL.");
    }
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 3 } }}>
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, sm: 3 },
          maxWidth: 600,
          mx: "auto",
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Typography variant="h5" fontWeight={600} gutterBottom    color="textPrimary">
          Add Homepage
        </Typography>
        <Typography variant="body2" color="textSecondary" mb={3}>
          (Add your homepage URL below. We’ll fetch most links automatically. The URL should start with
          <strong> https:// </strong> or <strong>www</strong>.)
        </Typography>

        <Stack spacing={2}>
          <TextField
            fullWidth
            label="Homepage URL"
            variant="outlined"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            error={!!error && !urlRegex.test(inputValue)}
          />

          {permission.canModify && (
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddWebBtnClick}
              disabled={isProcessing}
            >
              {isProcessing ? <CircularProgress size={24} color="inherit" /> : "Add Homepage"}
            </Button>
          )}

          {error && (
            <Alert
              severity={error.includes("successfully") ? "success" : "warning"}
              sx={{ mt: 2 }}
            >
              {error}
            </Alert>
          )}
        </Stack>
      </Paper>
    </Box>
  );
}
